"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStencilContext = exports.stencilProviderDefaultProps = exports.directionCache = exports.StencilProvider = exports.StencilContextProvider = exports.StencilContext = exports.StencilConsumer = exports.STENCIL_CONTEXT_PROPS = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _cache = _interopRequireDefault(require("@emotion/cache"));
var _react2 = require("@emotion/react");
var _stylisPluginRtl = _interopRequireDefault(require("stylis-plugin-rtl"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _stencilReactThemeDefault = _interopRequireWildcard(require("@amzn/stencil-react-theme-default"));
var _stencilReactUtils = require("@amzn/stencil-react-utils");
var _DisplayContentsContainer = require("../_helpers/DisplayContentsContainer");
var _WindowContext = require("../helpers/WindowContext");
var _utils2 = require("../responsive/utils");
var _isEmpty = require("../utils/isEmpty");
var _isHighContrast = _interopRequireDefault(require("../utils/isHighContrast"));
var _isSSR = require("../utils/isSSR");
var _liveAnnouncer = require("../live-announcer");
var _utils3 = require("../utils");
var _GetGlobalVariables = require("./GetGlobalVariables");
var _GlobalCSS = require("./GlobalCSS");
var _ScopeContext = require("./ScopeContext");
var _constants = require("./constants");
var _FontLoader = require("./font-loader/FontLoader");
var _interfaces = require("./interfaces");
var _utils4 = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//it is important to use the exact path to avoid recursive imports

const directionCache = exports.directionCache = {
  rtl: (0, _cache.default)({
    key: 'css-rtl',
    stylisPlugins: [_stylisPluginRtl.default]
  }),
  ltr: (0, _cache.default)({
    key: 'css'
  })
};
const DirectionWrapper = _ref => {
  let {
    isRTL,
    children
  } = _ref;
  if (isRTL) {
    return (0, _react2.jsx)("div", {
      dir: "rtl"
    }, children);
  }
  return (0, _react2.jsx)(_react.default.Fragment, null, children);
};
const getMediaQueryFn = breakpoint => {
  return breakpointStyles => {
    return {
      [(0, _utils2.buildMediaQuery)(breakpoint, true)]: breakpointStyles
    };
  };
};
const useStencilContext = () => {
  // Investigate why selectors is not coming from stencil context
  const stencilContext = (0, _react.useContext)(StencilContext);
  const stencilThemeContext = (0, _react.useContext)(_stencilReactThemeDefault.StencilThemeContext);

  //context has sensible defaults set. selectors will be empty if not wrapped in StencilProvider
  if (!(0, _stencilReactUtils.envIsProduction)() && !(0, _stencilReactUtils.envIsTest)() && (0, _isEmpty.isEmpty)(stencilThemeContext.selectors)) {
    throw new Error(_constants.CONTEXT_NOT_FOUND_ERROR_MESSAGE);
  }
  const {
    isInHighContrast,
    isRTL,
    setIsRTL,
    mode,
    themeMode
  } = stencilContext;
  const {
    legacyTheme,
    selectors,
    setLegacyTheme,
    breakpoints
  } = stencilThemeContext;
  return {
    isInHighContrast,
    isRTL,
    setIsRTL,
    mode,
    themeMode,
    selectors,
    theme: legacyTheme,
    setTheme: setLegacyTheme,
    breakpoints
  };
};
exports.useStencilContext = useStencilContext;
const StencilContext = exports.StencilContext = /*#__PURE__*/(0, _react.createContext)({
  theme: _stencilReactThemeDefault.default,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTheme: _ => null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIsRTL: _ => null,
  // @ts-ignore There's no sensible default for 'selectors'
  selectors: {},
  themeMode: _interfaces.ThemeMode.Light,
  breakpoints: _utils.breakpoints
});
const STENCIL_CONTEXT_PROPS = exports.STENCIL_CONTEXT_PROPS = ['theme', 'setTheme', 'selectors'];
const stencilProviderDefaultProps = exports.stencilProviderDefaultProps = {
  theme: _stencilReactThemeDefault.default,
  shouldAddLiveAnnouncer: true,
  shouldUseResponsiveText: true,
  mode: 'default',
  isRTL: false,
  isNested: false,
  breakpoints: _utils.breakpoints
};
const StencilContextProvider = forwardedProps => {
  const props = {
    ...stencilProviderDefaultProps,
    ...forwardedProps
  };
  const [isRTL, setIsRTL] = (0, _react.useState)(props.isRTL || false);
  const [isInHighContrast] = (0, _react.useState)(() => (0, _isHighContrast.default)());
  const {
    window: targetWindow
  } = (0, _react.useContext)(_WindowContext.WindowContext);
  //if the provider is inside an iframe use the iframe document
  let targetDocument = null;
  if (targetWindow) {
    targetDocument = targetWindow.document;
  } else if (!(0, _isSSR.isSSR)()) {
    targetDocument = document;
  }
  const {
    selectors,
    setLegacyTheme,
    legacyTheme,
    theme,
    breakpoints: mappedBreakpoints,
    isDefaultStencilThemeCustomized,
    isLegacyThemeCustomized
  } = (0, _react.useContext)(_stencilReactThemeDefault.StencilThemeContext);
  const getCache = isRTL => isRTL ? directionCache.rtl : directionCache.ltr;
  const getMediaQuery = props.getMediaQueryFn || getMediaQueryFn;
  const mediaQueries = {
    sm: getMediaQuery(mappedBreakpoints['s']),
    md: getMediaQuery(mappedBreakpoints['m']),
    lg: getMediaQuery(mappedBreakpoints['l']),
    xl: getMediaQuery(mappedBreakpoints['xl'])
  };
  const {
    children,
    emberUrl,
    emotionCache,
    shouldAddLiveAnnouncer,
    shouldUseResponsiveText,
    mode,
    isNested,
    themeMode,
    theme: externalTheme
  } = props;
  const scopeId = (0, _react.useMemo)(() => (0, _utils3.getUniqueHash)('SCOPE'), []);
  const shouldUseScopedWrapper = isDefaultStencilThemeCustomized || isLegacyThemeCustomized ||
  //this optimization is done to avoid creating scopes(adding dedicated variables) for all nested providers.
  isNested && externalTheme !== undefined;
  (0, _react.useEffect)(() => {
    if (!isNested && targetDocument && targetDocument.documentElement) {
      if (themeMode === _interfaces.ThemeMode.Dark) {
        targetDocument.documentElement.setAttribute(_utils.PREFERS_COLOR_SCHEME_ID, _interfaces.ThemeMode.Dark);
      } else {
        targetDocument.documentElement.setAttribute(_utils.PREFERS_COLOR_SCHEME_ID, _interfaces.ThemeMode.Light);
      }
    }
  }, [themeMode, targetDocument, isNested]);
  const emotionTheme = {
    isInHighContrast,
    isRTL,
    mode,
    selectors,
    shouldUseResponsiveText,
    values: legacyTheme,
    breakpoints: mappedBreakpoints,
    mediaQueries,
    utils: {
      mergeStyles: _utils2.mergeStyles
    },
    themeMode
  };
  const themeWithDefaultColor = (0, _utils4.getThemeWithDefaultColor)(theme);
  const globalCSS = (0, _GlobalCSS.getGlobalCSS)();
  const globalVariables = (0, _GetGlobalVariables.getGlobalVariables)(emotionTheme);
  let designTokenVariables;
  if (shouldUseScopedWrapper) {
    designTokenVariables = (0, _utils4.getScopedVariables)({
      theme: themeWithDefaultColor,
      scopeId
    });
  } else {
    designTokenVariables = themeWithDefaultColor;
  }
  const content = (0, _react2.jsx)(_react.default.Fragment, null, shouldAddLiveAnnouncer ? (0, _react2.jsx)(_liveAnnouncer.LiveAnnouncer, null, children) : children, !isNested && (0, _react2.jsx)(_FontLoader.FontLoader, {
    emberUrl: emberUrl
  }), !isNested && (0, _react2.jsx)(_react2.Global, {
    styles: globalVariables
  }), !isNested && (0, _react2.jsx)(_react2.Global, {
    styles: globalCSS
  }), (0, _react2.jsx)(_react2.Global, {
    styles: designTokenVariables
  }));
  const contextValue = (0, _react.useMemo)(() => ({
    isRTL,
    mode,
    selectors,
    setIsRTL,
    setTheme: setLegacyTheme,
    theme: legacyTheme,
    isInHighContrast,
    breakpoints: mappedBreakpoints,
    themeMode
  }), [isRTL, mode, selectors, setIsRTL, setLegacyTheme, legacyTheme, isInHighContrast, mappedBreakpoints, themeMode]);
  const innerContent = (0, _react2.jsx)(DirectionWrapper, {
    isRTL: isRTL
  }, (0, _react2.jsx)(_react2.ThemeProvider, {
    theme: emotionTheme
  }, (0, _react2.jsx)(_react2.CacheProvider, {
    value: getCache(isRTL)
  }, !!emotionCache ? (0, _react2.jsx)(_react2.CacheProvider, {
    value: emotionCache
  }, content) : content)));
  return (0, _react2.jsx)(StencilContext.Provider, {
    value: contextValue
  }, shouldUseScopedWrapper ? (0, _react2.jsx)(_ScopeContext.ScopeContext.Provider, {
    value: scopeId
  }, (0, _react2.jsx)(_DisplayContentsContainer.DisplayContentsContainer, (0, _utils3.getScopedThemeProps)({
    scopeId
  }), innerContent)) : innerContent);
};
exports.StencilContextProvider = StencilContextProvider;
const StencilProvider = _ref2 => {
  let {
    children,
    theme,
    breakpoints,
    ...props
  } = _ref2;
  return (0, _react2.jsx)(_stencilReactThemeDefault.StencilThemeProvider, {
    theme: theme,
    breakpoints: breakpoints || _utils.breakpoints
  }, (0, _react2.jsx)(StencilContextProvider, (0, _extends2.default)({}, props, {
    theme: theme
  }), children));
};

// Only the Context object can have a display name, not the consumer.
// The consumer will automatically be named `${Context.displayName}.Consumer`
exports.StencilProvider = StencilProvider;
StencilContext.displayName = 'StencilContext';
const StencilConsumer = exports.StencilConsumer = StencilContext.Consumer;